/** Open real app screens from Formation without leaving the training tab (GSD dual-tab pattern). */

export const FORMATION_PRACTICE_WINDOW_NAME = "shotokan-formation-practice";

/**
 * Resolve an in-app path to an absolute URL on the current origin (DEV/PROD).
 * @param {string} routePath
 * @returns {string}
 */
export function formationPracticeHref(routePath) {
  if (!routePath) return "/";
  if (/^https?:\/\//i.test(routePath)) return routePath;
  const path = routePath.startsWith("/") ? routePath : `/${routePath}`;
  if (typeof window === "undefined") return path;
  return `${window.location.origin}${path}`;
}

/**
 * Open (or reuse) the Formation practice tab. Keeps the Formation tab intact.
 * Named window reuses one practice tab across steps (avoids tab explosion).
 * @param {string} routePath
 * @returns {Window|null}
 */
export function openFormationPracticeTab(routePath) {
  if (typeof window === "undefined") return null;
  const href = formationPracticeHref(routePath);
  try {
    const win = window.open(href, FORMATION_PRACTICE_WINDOW_NAME);
    if (win && win !== window) {
      try {
        win.focus();
      } catch {
        /* ignore */
      }
      return win;
    }
    if (!win) {
      return window.open(href, "_blank");
    }
    return null;
  } catch {
    try {
      return window.open(href, "_blank");
    } catch {
      return null;
    }
  }
}
